import RootState from '@/store/root_state';
import { ExerciseCommentAttachmentState } from '@/store/modules/exerciseCommentAttachments/state';
import { GetterTree } from 'vuex';
import {
  ExerciseCommentAttachmentInfo,
  ExerciseCommentAttachmentModel,
} from '@descomplica/dex-models';

const getters: GetterTree<ExerciseCommentAttachmentState, RootState> = {
  exerciseCommentAttachmentsById:
    (state, ExerciseCommentAttachmentsGetters) =>
    (attachmentId: number): ExerciseCommentAttachmentModel | undefined => {
      const exerciseCommentAttachments: ExerciseCommentAttachmentInfo =
        state.exerciseCommentAttachments[attachmentId.toString()];

      return exerciseCommentAttachments
        ? new ExerciseCommentAttachmentModel(
            exerciseCommentAttachments,
            ExerciseCommentAttachmentsGetters,
          )
        : undefined;
    },
};

export default getters;
